import { apiFetch } from './client'

export const analyticsApi = {
  get: (token: string, days: string | number = 30, customer = 'all') => {
    const params = new URLSearchParams({ days: String(days) })
    if (customer && customer !== 'all') params.set('customer', customer)
    return apiFetch<any>(`/analytics?${params}`, token)
  },
}
